module.exports = __webpack_public_path__ + "static/media/400410_01.996ed82f.png";